import React from 'react';
import {SectionNotification, SectionNotificationType} from '@wix/wix-ui-tpa';
import {Alert, Error} from '@wix/wix-ui-icons-common/on-stage';
import {SanitizeInnerHTMLWrapper} from '@wix/ecom-platform-storefront-common';
import s from './ViolationNotification.scss';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {ViolationModel, ViolationSeverity} from '../../../../domain/models/CartSummary/Violation.model';

export enum ViolationNotificationDataHook {
  Root = 'ViolationNotificationDataHook.Root',
  Message = 'ViolationNotificationDataHook.Message',
  Icon = 'ViolationNotificationDataHook.Icon',
}

export interface ViolationNotificationProps {
  violation: ViolationModel;
}

export const ViolationNotification = ({violation}: ViolationNotificationProps) => {
  const {t} = useTranslation();
  const type =
    violation.severity === ViolationSeverity.error ? SectionNotificationType.error : SectionNotificationType.alert;
  const Icon = violation.severity === ViolationSeverity.error ? Error : Alert;
  const iconClassName = violation.severity === ViolationSeverity.error ? s.errorIcon : s.alertIcon;
  const srLabel =
    violation.severity === ViolationSeverity.error
      ? 'sideCart.validationErrorIcon.ariaLabel'
      : 'sideCart.validationWarningIcon.ariaLabel';
  return (
    <SectionNotification type={type} data-hook={ViolationNotificationDataHook.Root}>
      <SectionNotification.Icon icon={<Icon className={iconClassName} />} />
      <SectionNotification.Text>
        <span className={'sr-only'}>{t(srLabel)}</span>
        <SanitizeInnerHTMLWrapper innerHtml={violation.description}>
          <span data-hook={ViolationNotificationDataHook.Message} />
        </SanitizeInnerHTMLWrapper>
      </SectionNotification.Text>
    </SectionNotification>
  );
};
